import { all, call } from 'redux-saga/effects';
import { userSagas } from './user/user.sagas';
import { courseSagas } from './courses/course.sagas';
import { reviewSagas } from './reviews/review.sagas';

export default function* rootSaga() {
  yield all([call(userSagas), call(courseSagas), call(reviewSagas)]);
}
